<template>
    <a-modal
    title="融资申请"
    v-model="modalShow"
    width="600px"
    @ok="handleOk"
    @cancel="close"
    :confirm-loading="confirmLoading"
    destroyOnClose>
        <a-form-model
        class="common-form-inline"
        :rules="rules"
        ref="ruleForm"
        :model="pageData"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 17 }"
        >
            <a-form-model-item label="祺信编号" prop="gldId" class="finance-item">
                {{pageData.gldId}}
            </a-form-model-item>
            <a-form-model-item label="开立方" prop="estbNm" class="finance-item">
                {{pageData.estbNm}}
            </a-form-model-item>
            <a-form-model-item label="流转方" prop="pyptNm" class="finance-item">
                {{pageData.pyptNm}}
            </a-form-model-item>
            <a-form-model-item label="到期日期" prop="exDay" class="finance-item">
                {{pageData.exDay | dateFormat("YYYY-mm-dd")}}<span style="margin-left:10px;">（剩余天数：{{pageData.residueDays}}天）</span>
            </a-form-model-item>
            <a-form-model-item label="祺信余额(元)" prop="gldBal" class="finance-item">
                {{pageData.gldBal | splitK}}
            </a-form-model-item>
            <a-form-model-item label="本次融资金额(元)" prop="thsFncAmt">
                <a-input v-model="pageData.thsFncAmt" placeholder="请输入内容"/>
            </a-form-model-item>
            <a-form-model-item label="意向放款日期" prop="expectDate">
                <a-date-picker valueFormat="YYYY-MM-DD" v-model="pageData.expectDate" placeholder="请选择" :disabledDate="disabledDate" style="width:200px"/>
            </a-form-model-item>
            <a-form-model-item label="资金用途" prop="selectedTag">
                <a-radio-group name="selectedTag" v-model="pageData.selectedTag">
                    <a-radio v-for="tag in tags" :key="tag.value" :value="tag.value">
                        {{tag.name}}
                    </a-radio>
                </a-radio-group>
                <a-input v-if="pageData.selectedTag==2" v-model="pageData.areaVal" placeholder="请输入内容" style="width:200px"></a-input>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import {mapMutations,mapGetters} from "vuex"
import {mfamount,routeListApi} from "@/api/sell.js"
export default {
    props:{
      // 祺信融资选择的祺信列表
      info:{
        type:[Object],
        default:function(){
            return {}
        }
      }
    },
    data() {
        return {
            modalShow:false,
            confirmLoading:false,
            hgstCanFncAmt:0,
            pageData:{
                applyAmt:0,
                expectDate:undefined
            },
            rules:{
                thsFncAmt: [
                    {
                        required: true,
                        trigger: "blur",
                        whitespace:true,
                        validator:(rule,value,cbfn) => {
                            if (!value) {
                                cbfn('本次融资金额不能为空');
                            }
                            else if(Number(value) > Number(this.pageData.gldBal)){
                                cbfn(('融资金额不可大于祺信余额' + this.utils.splitK(this.pageData.gldBal)));
                            }
                            else{
                                cbfn();
                            }
                        }
                    }
                ],
                expectDate: [
                    {required: true,message: "意向放款日期不能为空",trigger: "change"}
                ],
                selectedTag: [
                    {required: true,message: "资金用途不能为空",trigger: "blur"}
                ],
            },
            tags:this.dict.useOfFunds,
            selectedTag:"",
            routeList:[]
        }
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj",
            parentData:"app/getGoldDetailPrarms"

        })
    },
    created() {
        this.mfamount();
    },
    methods: {
        ...mapMutations({
            setBuyOrSell:"app/setBuyOrSell",
            setFinancingDetailPrarms:"app/setFinancingDetailPrarms"
        }),
        open(){
            this.initPageData();
            this.modalShow = true;
            this.pageData.expectDate = window.sessionStorage.getItem("systemDate");
        },
        initPageData(){
            for(let k in this.info){
                this.$set(this.pageData,k,this.info[k]);
            }
        },
        close(){
            this.pageData = {};
            this.modalShow = false;
            this.confirmLoading = false;
        },
        mfamount(){ //获取最高可融资金额
            mfamount()
            .then(res => {
                this.hgstCanFncAmt = res.data.hgstCanFncAmt;
            })
            .catch(err => {
                console.log(err);
            })
        },
        disabledDate(cuurent){
            // 节假日
            // let day = new Date(cuurent).getDay();
            // if(day == 0 || day == 6){
            //     return true;
            // }
            // 小于t+1
            let today = new Date(this.utils.addDate(new Date(),0)).getTime();
            let curDay = new Date(cuurent).getTime();
            if(today >= curDay){
                return true;
            }
        },
        handleOk(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if(this.pageData.selectedTag == "2" && this.pageData.areaVal === ""){
                        this.$message.warn("请填写资金用途备注");
                        return;
                    }

                    this.confirmLoading = true;
                    const formStr = {
                        hgstCanFncAmt: this.hgstCanFncAmt,
                        applyDate: this.utils.dateFormat(new Date(),"yyyy-MM-dd"),
                        applyAmt: this.pageData.thsFncAmt,
                        cptlTpCd: this.pageData.selectedTag,
                        expectDate:this.pageData.expectDate
                    };
                    if(this.pageData.selectedTag == 2){
                        formStr.opin = this.pageData.areaVal;
                    }
                    const params = {
                        goldListStr: JSON.stringify([this.info]),
                        poolListStr: JSON.stringify([]),
                        rcvbListStr: JSON.stringify([]),
                        formStr: JSON.stringify(formStr),
                        rcvbCheckAll: '0',
                        gldId:this.info.gldId
                    };

                    // 获取资金方列表
                    let self = this;
                    routeListApi(params).then(res => {
                        this.routeList = res.data;
                        if(this.routeList.length == 0){
                            this.$error({
                                title: '当前祺信尚无适配资金方，请联系平台',
                                okText:'确定',
                                onOk(){
                                    self.close();
                                }
                            });
                            return;
                        }
                        let futureList = [
                          {
                            applyAmt: undefined,
                            bank: "beijing",
                            estInt: undefined,
                            expectDate: "",
                            fee: undefined,
                            financingFeeRatio: undefined,
                            financingFeeType: "0",
                            interest: undefined,
                            lmtBusinessInfEntity: "",
                            lmtId: "",
                            loanDays: undefined,
                            platformInt: undefined,
                            tenantId: "",
                            tenantName: "北京银行北京分行",
                            tenantOrgCode: "",
                            totalAmt: undefined,
                            yrRate: undefined,
                            error:"玩命对接中，敬请期待 --"
                          },
                          {
                            applyAmt: undefined,
                            bank: "pingan",
                            estInt: undefined,
                            expectDate: "",
                            fee: undefined,
                            financingFeeRatio: undefined,
                            financingFeeType: "0",
                            interest: undefined,
                            lmtBusinessInfEntity: "",
                            lmtId: "",
                            loanDays: undefined,
                            platformInt: undefined,
                            tenantId: "",
                            tenantName: "平安银行厦门分行",
                            tenantOrgCode: "",
                            totalAmt: undefined,
                            yrRate: undefined,
                            error:"玩命对接中，敬请期待 --"
                          }
                        ];

                        this.routeList = this.routeList.concat(futureList);
                        this.$emit("success",{
                            applayForm:formStr,
                            info:this.info,
                            submitParams:params,
                            routeList:this.routeList
                        });
                    }).catch(err => {
                        this.confirmLoading = false;
                    })

                } else {
                    return false;
                }
            });
        },

    },
    watch: {
        info(newVal){
            this.initPageData();
        }
    }
}
</script>
<style scoped lang="less">
    .text-item{
        width: 100%;
        margin-bottom:10px;
        color: #333;
    }
    .text-label{
        width: 90px;
        text-align: right;
        color:#777;

    }
    input{
        width: 200px;
        margin-right: 8px;
    }
    .finance-item{
        margin-bottom:10px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing-steps/gold-financing-modal.vue